<script lang="ts" setup>
defineProps<{
  links: { id: string; name: string; href: string }[]
}>()

const localeRoute = useLocaleRoute()

function isUrlSimple(str: string): boolean {
  return str.startsWith('http://') || str.startsWith('https://')
}

function resolveLink(str: string) {
  if (isUrlSimple(str) || str === '/checkin') {
    return str
  }

  return localeRoute(str)
}
</script>

<template>
  <UDropdownMenu
    :items="
      links.map((link) => ({
        label: $t(link.name),
        to: resolveLink(link.href),
        target: isUrlSimple(link.href) ? '_blank' : '_self',
      }))
    "
    :content="{
      align: 'start',
      side: 'bottom',
      sideOffset: 20,
    }"
    :ui="{
      content:
        'ring-0 bg-[#16161699] text-white backdrop-blur-xl rounded-lg shadow-lg transition-transform duration-200 ease-out origin-top',
      item: 'px-4 py-2 rounded-md text-white/70 hover:!text-white hover:bg-[#272727cc] transition-colors duration-200 flex items-center gap-2 cursor-pointer before:bg-transparent data-highlighted:text-pink-500',
    }"
  >
    <template #default="{ open }">
      <UButton
        variant="ghost"
        color="neutral"
        trailing-icon="i-lucide-chevron-down"
        :ui="{
          base: open
            ? 'text-white bg-transparent'
            : 'text-white/70 hover:text-white hover:bg-transparent bg-transparent active:bg-transparent transition-colors duration-200 cursor-pointer',
        }"
      >
        <slot name="title" />
      </UButton>
    </template>
  </UDropdownMenu>
</template>
